import store from 'store2';
window.storeClear = function () {
  store.session.clearAll();
};

export default class SessionStorage {
  constructor(namespace) {
    this.namespace = namespace;
    this.storage = store.session.namespace(namespace);
  }

  save(key, value, override = true) {
    this.storage.set(key, value, override);
  }

  get(key, alternative = null) {
    let data = this.storage.get(key, alternative);
    return data;
  }
  clear() {
    this.storage.clearAll();
  }
}

export class LocalStorage {
  constructor(namespace) {
    this.namespace = namespace;
    this.storage = store.local.namespace(namespace);
  }

  save(key, value, override = true) {
    this.storage.set(key, value, override);
  }

  get(key, alternative = null) {
    let data = this.storage.get(key, alternative);
    return data;
  }
}
